import React from "react";

import { PAGE_SIZE_OPTIONS } from "../../../utils/listQueryState";

const PageSizeSelect = ({ value = 10, onChange, disabled = false }) => (
  <div className="page-size-select">
    <span>Tampilkan</span>
    <select
      aria-label="Jumlah data per halaman"
      value={value}
      onChange={(event) => onChange?.(Number(event.target.value))}
      disabled={disabled}
    >
      {PAGE_SIZE_OPTIONS.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </select>
    <span>data per halaman</span>
  </div>
);

export default PageSizeSelect;
